export const ACTIVE_CLASS = 'is-kinde-active';
export const LIVE_REGION_TIMEOUT_MS = 2000;
